import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { CreditAnswer } from '../interfaces/credit-asnwer.interface';
const URL = `${URL_SERVICIOS}Generic`;

@Injectable({
  providedIn: 'root'
})
export class GenericService {

  constructor(public http: HttpClient) { }

  getQuotationByPetitionId = (id: number) => this.http.get<any>(`${URL}/quotation/${id}`, HTTP_OPTIONS);

  getInsuranceByPetitionId = (id: number) => this.http.get<any>(`${URL}/insurance/${id}`, HTTP_OPTIONS);

  createInsuranceByPetitionId = (id: number, insurance: any) => this.http.post<any>(`${URL}/InsuranceManagement/${id}`, insurance, HTTP_OPTIONS);

  putInsuranceByPetitionId = (id: number, insurance: any) => this.http.put<any>(`${URL}/InsuranceManagement/${id}`, insurance, HTTP_OPTIONS);


  getCreditAnswerByPetitionId = (petitionId: number) => this.http.get<CreditAnswer>(`${URL}/CreditAnswer/${petitionId}`);

  createCreditAnswer = (creditAnswer: CreditAnswer) => this.http.post<any>(`${URL}/CreditAnswer`, creditAnswer, HTTP_OPTIONS);

  updateCreditAnswer = (creditAnswer: CreditAnswer) => this.http.put<any>(`${URL}/CreditAnswer`, creditAnswer, HTTP_OPTIONS);
}